import React from 'react';
import Card from './Card';
import { slide_contents } from '../utils/data';
import { Container, Button, Stack, Grow } from '@mui/material';


const Home = () => {
  let slideCount = slide_contents.length;
  const [activeStep, setActiveStep] = React.useState(0);
  let selectedCard = null;
  for (let slide of slide_contents) {
    if (slide.no === activeStep) {
      selectedCard = <Card slideCount={slideCount} slide={slide} />;
    }

  }

  const handleSlideNext = () => {
    let no = activeStep + 1;
    if (no < slideCount) {
      setActiveStep(no);
    }
  }

  const handleSlidePrev = () => {
    let no = activeStep - 1;
    if (no >= 0) {
      setActiveStep(no);
    }
  }

  return (
    <Container sx={{ my: '5vh' }}>
      {selectedCard}
      <Stack spacing={2} sx={{ mt: 1 }} direction="row" justifyContent="center">
        {
          activeStep > 0 ?
            <Grow in={true}>
              <Button
                variant="contained"
                style={{ borderRadius: '180px', backgroundColor: '#747677' }}
                sx={{ px: 4 }}
                onClick={handleSlidePrev}
              >
                Prev
              </Button>
            </Grow> : null
        }
        {
          activeStep + 1 < slideCount ?
            <Grow in={true}>
              <Button
                variant="contained"
                style={{ borderRadius: '180px', backgroundColor: '#db0311' }}
                sx={{ px: 4 }}
                onClick={handleSlideNext}
              >
                Next
              </Button>
            </Grow> : null
        }
      </Stack>
    </Container>
  )
}

export default Home